"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEDIA_TYPE = exports.TRANSPARENT_FILL_COLOR = exports.DEFAULT_FILL_COLOR = exports.INVISIBLE_CONTENT_TYPES = exports.AUDIBLE_CONTENT_TYPES = exports.SHAPE_PROPERTIES = exports.SHAPE = exports.CONTENT_TYPE = exports.DEFAULT_KEYFRAME_TRANSFORM = exports.DEFAULT_KEYFRAME_NUMBER = exports.VALID_FILTERS = exports.FILTERS_TO_FILTER_NAMES = exports.FILTERS = exports.BLEND_MODE_TO_COMPOSITE_OPERATION = exports.CANVAS_COMPOSITE_OPERATIONS = exports.DEFAULT_ALPHA_BLEND_MODE = exports.ALPHA_BLEND_MODES = exports.VALID_EASING_FUNCTIONS = exports.EASING_FUNCTIONS = exports.EASE_IN_OUT_CUBIC = exports.EASE_OUT_CUBIC = exports.EASE_IN_CUBIC = exports.STEP = exports.LINEAR = exports.ROOT_MASK_KEY = exports.DEFAULT_STAGE_ALPHA = exports.DEFAULT_STAGE_COLOR = exports.DEFAULT_CREATIVE_LENGTH = exports.DEFAULT_CREATIVE_WIDTH_PX = exports.DEFAULT_CREATIVE_HEIGHT_PX = exports.MAX_FRAME_END = exports.PLAYBACK_FRAMES_PER_SECOND = exports.VALID_CREATIVE_MODES = exports.CREATIVE_MODES = exports.CURRENT_CREATIVE_FORMAT_VERSION = exports.CREATIVE_FORMAT_VERSION_V4 = exports.CREATIVE_FORMAT_VERSION_V3 = exports.CREATIVE_FORMAT_VERSION_V2 = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _EASING_FUNCTIONS, _BLEND_MODE_TO_COMPOS, _SHAPE_PROPERTIES;

/*
  History of creative version numbers

  Version 1: Original creative version - had different top-level model objects. Elements could
  reference media or content or text.

  Version 2: Simplified and more "scalable" model where elements have content which can contain media.

  Version 3: Fixed a snap-level off-by-one frame count error persisted in older versions

  Version 4: Fixed frame rate conversion for keyframes and individual layers.
 */
var CREATIVE_FORMAT_VERSION_V2 = 2;
exports.CREATIVE_FORMAT_VERSION_V2 = CREATIVE_FORMAT_VERSION_V2;
var CREATIVE_FORMAT_VERSION_V3 = 3;
exports.CREATIVE_FORMAT_VERSION_V3 = CREATIVE_FORMAT_VERSION_V3;
var CREATIVE_FORMAT_VERSION_V4 = 4;
exports.CREATIVE_FORMAT_VERSION_V4 = CREATIVE_FORMAT_VERSION_V4;
var CURRENT_CREATIVE_FORMAT_VERSION = CREATIVE_FORMAT_VERSION_V4;
exports.CURRENT_CREATIVE_FORMAT_VERSION = CURRENT_CREATIVE_FORMAT_VERSION;
var CREATIVE_MODES = {
  ADVANCED: 'ADVANCED',
  SIMPLE: 'SIMPLE',
  SHOWS: 'SHOWS'
};
exports.CREATIVE_MODES = CREATIVE_MODES;
var VALID_CREATIVE_MODES = new Set(Object.keys(CREATIVE_MODES));
exports.VALID_CREATIVE_MODES = VALID_CREATIVE_MODES;
var PLAYBACK_FRAMES_PER_SECOND = 30;
exports.PLAYBACK_FRAMES_PER_SECOND = PLAYBACK_FRAMES_PER_SECOND;
var MAX_FRAME_END = 180 * PLAYBACK_FRAMES_PER_SECOND;
exports.MAX_FRAME_END = MAX_FRAME_END;
var DEFAULT_CREATIVE_HEIGHT_PX = 1920;
exports.DEFAULT_CREATIVE_HEIGHT_PX = DEFAULT_CREATIVE_HEIGHT_PX;
var DEFAULT_CREATIVE_WIDTH_PX = 1080;
exports.DEFAULT_CREATIVE_WIDTH_PX = DEFAULT_CREATIVE_WIDTH_PX;
var DEFAULT_CREATIVE_LENGTH = 5 * PLAYBACK_FRAMES_PER_SECOND - 1; // 5 seconds

exports.DEFAULT_CREATIVE_LENGTH = DEFAULT_CREATIVE_LENGTH;
var DEFAULT_STAGE_COLOR = '#FFFFFF';
exports.DEFAULT_STAGE_COLOR = DEFAULT_STAGE_COLOR;
var DEFAULT_STAGE_ALPHA = 1;
exports.DEFAULT_STAGE_ALPHA = DEFAULT_STAGE_ALPHA;
var ROOT_MASK_KEY = 'root';
/*
 * element document constants
 */

exports.ROOT_MASK_KEY = ROOT_MASK_KEY;
var LINEAR = 'LINEAR';
exports.LINEAR = LINEAR;
var STEP = 'STEP';
exports.STEP = STEP;
var EASE_IN_CUBIC = 'EASE_IN_CUBIC';
exports.EASE_IN_CUBIC = EASE_IN_CUBIC;
var EASE_OUT_CUBIC = 'EASE_OUT_CUBIC';
exports.EASE_OUT_CUBIC = EASE_OUT_CUBIC;
var EASE_IN_OUT_CUBIC = 'EASE_IN_OUT_CUBIC';
exports.EASE_IN_OUT_CUBIC = EASE_IN_OUT_CUBIC;
var EASING_FUNCTIONS = (_EASING_FUNCTIONS = {}, (0, _defineProperty2["default"])(_EASING_FUNCTIONS, LINEAR, function (t) {
  return t;
}), (0, _defineProperty2["default"])(_EASING_FUNCTIONS, STEP, function (t) {
  return t > 1 - 1e-6 ? 1 : 0;
}), (0, _defineProperty2["default"])(_EASING_FUNCTIONS, EASE_IN_CUBIC, function (t) {
  return t * t * t;
}), (0, _defineProperty2["default"])(_EASING_FUNCTIONS, EASE_OUT_CUBIC, function (t) {
  var s = t - 1;
  return s * s * s + 1;
}), (0, _defineProperty2["default"])(_EASING_FUNCTIONS, EASE_IN_OUT_CUBIC, function (t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}), _EASING_FUNCTIONS);
exports.EASING_FUNCTIONS = EASING_FUNCTIONS;
var VALID_EASING_FUNCTIONS = new Set(Object.keys(EASING_FUNCTIONS)); // alpha blend modes

exports.VALID_EASING_FUNCTIONS = VALID_EASING_FUNCTIONS;
var ALPHA_BLEND_MODES = {
  DST_ATOP: 'DST_ATOP',
  DST_IN: 'DST_IN',
  DST_OUT: 'DST_OUT',
  DST_OVER: 'DST_OVER',
  SRC_ATOP: 'SRC_ATOP',
  SRC_IN: 'SRC_IN',
  SRC_OUT: 'SRC_OUT',
  SRC_OVER: 'SRC_OVER',
  XOR: 'XOR'
};
exports.ALPHA_BLEND_MODES = ALPHA_BLEND_MODES;
var DEFAULT_ALPHA_BLEND_MODE = ALPHA_BLEND_MODES.SRC_OVER;
/*
 TODO:
 "lighter"
 "copy"
 "multiply"
 "screen"
 "overlay"
 "darken"
 "color-dodge"
 "color-burn"
 "hard-light"
 "soft-light"
 "difference"
 "exclusion"
 "hue"
 "saturation"
 "color"
 "luminosity"
 */

exports.DEFAULT_ALPHA_BLEND_MODE = DEFAULT_ALPHA_BLEND_MODE;
var CANVAS_COMPOSITE_OPERATIONS = {
  DESTINATION_ATOP: 'destination-atop',
  DESTINATION_IN: 'destination-in',
  DESTINATION_OUT: 'destination-out',
  DESTINATION_OVER: 'destination-over',
  SOURCE_ATOP: 'source-atop',
  SOURCE_IN: 'source-in',
  SOURCE_OUT: 'source-out',
  SOURCE_OVER: 'source-over',
  XOR: 'xor'
};
exports.CANVAS_COMPOSITE_OPERATIONS = CANVAS_COMPOSITE_OPERATIONS;
var BLEND_MODE_TO_COMPOSITE_OPERATION = (_BLEND_MODE_TO_COMPOS = {}, (0, _defineProperty2["default"])(_BLEND_MODE_TO_COMPOS, ALPHA_BLEND_MODES.DST_ATOP, CANVAS_COMPOSITE_OPERATIONS.DESTINATION_ATOP), (0, _defineProperty2["default"])(_BLEND_MODE_TO_COMPOS, ALPHA_BLEND_MODES.DST_IN, CANVAS_COMPOSITE_OPERATIONS.DESTINATION_IN), (0, _defineProperty2["default"])(_BLEND_MODE_TO_COMPOS, ALPHA_BLEND_MODES.DST_OUT, CANVAS_COMPOSITE_OPERATIONS.DESTINATION_OUT), (0, _defineProperty2["default"])(_BLEND_MODE_TO_COMPOS, ALPHA_BLEND_MODES.DST_OVER, CANVAS_COMPOSITE_OPERATIONS.DESTINATION_OVER), (0, _defineProperty2["default"])(_BLEND_MODE_TO_COMPOS, ALPHA_BLEND_MODES.SRC_ATOP, CANVAS_COMPOSITE_OPERATIONS.SOURCE_ATOP), (0, _defineProperty2["default"])(_BLEND_MODE_TO_COMPOS, ALPHA_BLEND_MODES.SRC_IN, CANVAS_COMPOSITE_OPERATIONS.SOURCE_IN), (0, _defineProperty2["default"])(_BLEND_MODE_TO_COMPOS, ALPHA_BLEND_MODES.SRC_OUT, CANVAS_COMPOSITE_OPERATIONS.SOURCE_OUT), (0, _defineProperty2["default"])(_BLEND_MODE_TO_COMPOS, ALPHA_BLEND_MODES.SRC_OVER, CANVAS_COMPOSITE_OPERATIONS.SOURCE_OVER), (0, _defineProperty2["default"])(_BLEND_MODE_TO_COMPOS, ALPHA_BLEND_MODES.XOR, CANVAS_COMPOSITE_OPERATIONS.XOR), _BLEND_MODE_TO_COMPOS); // filters

exports.BLEND_MODE_TO_COMPOSITE_OPERATION = BLEND_MODE_TO_COMPOSITE_OPERATION;
var FILTERS = {
  BLUR: 'BLUR' // WOO HOO!

};
exports.FILTERS = FILTERS;
var FILTERS_TO_FILTER_NAMES = (0, _defineProperty2["default"])({}, FILTERS.BLUR, 'blur');
exports.FILTERS_TO_FILTER_NAMES = FILTERS_TO_FILTER_NAMES;
var VALID_FILTERS = new Set(Object.keys(FILTERS).map(function (key) {
  return FILTERS_TO_FILTER_NAMES[key];
})); // default transform

exports.VALID_FILTERS = VALID_FILTERS;
var DEFAULT_KEYFRAME_NUMBER = -1;
exports.DEFAULT_KEYFRAME_NUMBER = DEFAULT_KEYFRAME_NUMBER;
var DEFAULT_KEYFRAME_TRANSFORM = {
  alpha: 1,
  easingFunction: LINEAR,
  filters: {
    filtersByName: {
      blur: {
        radius: 0
      }
    },
    filters: ['blur']
  },
  rotation: 0,
  scale: {
    x: 1,
    y: 1
  },
  setId: null,
  setOrder: null,
  translation: {
    x: 0,
    y: 0
  }
};
/*
 * content document constants
 */

exports.DEFAULT_KEYFRAME_TRANSFORM = DEFAULT_KEYFRAME_TRANSFORM;
var CONTENT_TYPE = {
  AUDIO: 'AUDIO',
  // An audio clip
  ELEMENT_EFFECT_GROUP: 'ELEMENT_EFFECT_GROUP',
  // A group of element, but will be displayed as one single layer
  ELEMENT_GROUP: 'ELEMENT_GROUP',
  // A group of elements, some that can mask others
  IMAGE: 'IMAGE',
  // A raster image
  SHAPE: 'SHAPE',
  // A vector shape (circle, square, etc.)
  SVG: 'SVG',
  // A vector image
  TEXT: 'TEXT',
  // A vector text block
  VIDEO: 'VIDEO' // A video clip

};
exports.CONTENT_TYPE = CONTENT_TYPE;
var SHAPE = {
  SQUARE: 'SQUARE',
  CIRCLE: 'CIRCLE',
  STAR: 'STAR'
};
exports.SHAPE = SHAPE;
var SHAPE_PROPERTIES = (_SHAPE_PROPERTIES = {}, (0, _defineProperty2["default"])(_SHAPE_PROPERTIES, SHAPE.SQUARE, {
  id: SHAPE.SQUARE,
  width: 400,
  height: 400
}), (0, _defineProperty2["default"])(_SHAPE_PROPERTIES, SHAPE.CIRCLE, {
  id: SHAPE.CIRCLE,
  width: 400,
  height: 400
}), (0, _defineProperty2["default"])(_SHAPE_PROPERTIES, SHAPE.STAR, {
  id: SHAPE.STAR,
  width: 400,
  height: 400
}), _SHAPE_PROPERTIES);
exports.SHAPE_PROPERTIES = SHAPE_PROPERTIES;
var AUDIBLE_CONTENT_TYPES = new Set([CONTENT_TYPE.AUDIO, CONTENT_TYPE.VIDEO]);
exports.AUDIBLE_CONTENT_TYPES = AUDIBLE_CONTENT_TYPES;
var INVISIBLE_CONTENT_TYPES = new Set([CONTENT_TYPE.AUDIO]); // text content specific constants

exports.INVISIBLE_CONTENT_TYPES = INVISIBLE_CONTENT_TYPES;
var DEFAULT_FILL_COLOR = '#000000';
exports.DEFAULT_FILL_COLOR = DEFAULT_FILL_COLOR;
var TRANSPARENT_FILL_COLOR = 'transparent';
/*
 * media document constants
 */

exports.TRANSPARENT_FILL_COLOR = TRANSPARENT_FILL_COLOR;
var MEDIA_TYPE = {
  IMAGE: 'IMAGE',
  // a raster image file in GCS
  VIDEO: 'VIDEO',
  // a video file in GCS
  AUDIO: 'AUDIO',
  // an audio file in GCS
  SVG: 'SVG',
  // an SVG file in GCS
  INLINE_SVG: 'INLINE_SVG' // inline SVG with no file in GCS

};
exports.MEDIA_TYPE = MEDIA_TYPE;